export class AiImageCache {
  private urlCache = new Map<string, string>()

  setImageUrl(key: string, url: string): void {
    const existing = this.urlCache.get(key)
    if (existing) {
      URL.revokeObjectURL(existing)
    }
    this.urlCache.set(key, url)
  }

  getImageUrl(key: string): string {
    return this.urlCache.get(key) ?? ''
  }

  hasImageUrl(key: string): boolean {
    return this.urlCache.has(key)
  }

  revoke(key: string): void {
    const url = this.urlCache.get(key)
    if (url) {
      URL.revokeObjectURL(url)
      this.urlCache.delete(key)
    }
  }

  revokeAll(): void {
    this.urlCache.forEach((url) => URL.revokeObjectURL(url))
    this.urlCache.clear()
  }
}
